import { useEffect, useState } from 'react';
import Drawer from '@mui/material/Drawer';
import { Box, IconButton } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import eventBus, { eventBusValues } from '../eventBus';
import CompanyAccount from '../scenes/CompanyAccount';

const CompanyAccountSettingsDrawer = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleOpen = () => setOpen(true);
    document.addEventListener(
      eventBusValues.companyAccountSettings,
      handleOpen
    );
    eventBus.on('bottomNavigationClick', () => {
      setOpen(false);
    });

    return () => {
      document.removeEventListener(
        eventBusValues.companyAccountSettings,
        handleOpen
      );
      eventBus.remove('bottomNavigationClick');
    };
  }, []);

  const handleClose = () => setOpen(false);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      PaperProps={{ sx: { maxWidth: '100vw' } }}
    >
      <Box sx={{ position: 'relative', width: '100%', minHeight: '100vh', marginBottom: '56px' }}>
        <Box
          sx={{
            position: 'absolute',
            left: 16,
            top: 16,
            zIndex: 10,
          }}
        >
          <IconButton onClick={handleClose} size="small">
            <ArrowForwardIosIcon sx={{ color: '#0F78FD' }} />
          </IconButton>
        </Box>
        <Box sx={{ height: '100vh', overflowY: 'auto' }}>
          <Box sx={{ height: '30px' }} />
          <CompanyAccount />
        </Box>
      </Box>
    </Drawer>
  );
};

export default CompanyAccountSettingsDrawer;
